import { render } from "./CaaChatbot.vue?vue&type=template&id=01fb8f9e"
import script from "./CaaChatbot.vue?vue&type=script&lang=js"
export * from "./CaaChatbot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__